import { render, staticRenderFns } from "./StatsPad.vue?vue&type=template&id=9f44fcb8&scoped=true&"
import script from "./StatsPad.vue?vue&type=script&lang=js&"
export * from "./StatsPad.vue?vue&type=script&lang=js&"
import style0 from "./StatsPad.vue?vue&type=style&index=0&id=9f44fcb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f44fcb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f44fcb8')) {
      api.createRecord('9f44fcb8', component.options)
    } else {
      api.reload('9f44fcb8', component.options)
    }
    module.hot.accept("./StatsPad.vue?vue&type=template&id=9f44fcb8&scoped=true&", function () {
      api.rerender('9f44fcb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StatsPad.vue"
export default component.exports